import { ApolloProvider } from '@apollo/client';
import { getToken } from 'functions/token';
import client from "./client"

const CptQueryProvider = ({ children }) => {
    const token = getToken();
    return (
        <ApolloProvider client={client(token)}>
            {children}
        </ApolloProvider>
    )
}

export {
    CptQueryProvider
}